import React from 'react'

const OfferHeading = () => {
  return (
      <div className='offerDiv'>
          <p>
              Explore 100% online Degrees and Certificates on DevLearn.
          </p>
    </div>
  )
}

export default OfferHeading